import {dataFetcher} from "../../services/dataGuetter/dataFetcher";


export function addNavigation(datas:AddNavigation):Promise<Navigation>{
    return dataFetcher(`navigations`, {
        method:'post',
        body:datas
    })
}